<template>
  <div class="tab-view">
    <div class="passes-text">
      Play Passes
      <div class="passes-count">{{ userStore.user?.passes }}
        <IconPass />
      </div>
    </div>

    <div @click="play" class="play-button">
      <div class="play-button-title">Help Leea Protocol</div>
      <div class="play-button-description">Process & Sort Datasets</div>
      <LeeaBtn class="play-button-action" color="blue" round width="100px">PLAY</LeeaBtn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { analyticsService } from '@/services/analytics.service'

import IconPass from './Icons/IconPass.vue'
import LeeaBtn from './LeeaBtn.vue'
import { useRouter } from 'vue-router'

analyticsService.logTab('Play')

const userStore = useUserStore()
const router = useRouter()

const play = async () => {
  await userStore.fetchUser()
  if (!userStore.user?.passes) {
    ElMessage.warning('No Play Passes left :(')
    return
  }
  router.push('/game')
}
</script>

<style lang="scss" scoped>
.tab-view {
  justify-content: space-between;
}

.passes-text {
  font-family: 'Forma DJR Display';
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.04em;
  margin-bottom: 20px;

  .passes-count {
    font-family: 'Forma DJR Display';
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.04em;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .icon {
      fill: black;
    }
  }
}

.play-button {
  background: url('@/assets/Game.png');
  background-size: cover;
  background-position: top right;
  width: 100%;
  height: 190px;
  border-radius: 20px;
  border: 1px solid lightgray;
  padding: 20px;
  box-sizing: border-box;
  z-index: 1;

  display: flex;
  flex-direction: column;

  .play-button-title {
    font-size: 30px;
    font-family: 'Forma DJR Display';
    font-weight: 700;
    letter-spacing: 0.04em;
    margin-bottom: 8px;
  }

  .play-button-action {
    margin-top: auto;
    // font-size: 20px;
    // color: var(--blue-color);
  }
}
</style>
